import { PAGE_SIZE } from "../../../../constants/Config";
import {
    PAYMENT_DELETE,
    PAYMENT_DETAIL,
    PAYMENT_INSERT,
    PAYMENT_LIST,
    PAYMENT_UPDATE,
    PAYMENT_GETALL
} from "./action-types";


const initialState = {
    data: [],
    totalRows: 0,
    currentPage: 0,
    pageSize: PAGE_SIZE,
    items: [],
    item: null,
    suggestion: []
}

const reducer = (state = initialState, { type, payload = null }) => {
    switch (type) {
        case PAYMENT_LIST:
            return list(state, payload)
        case PAYMENT_DETAIL:
            return detail(state, payload)
        case PAYMENT_UPDATE:
            return update(state, payload)
        case PAYMENT_INSERT:
            return insert(state, payload)
        case PAYMENT_DELETE:
            return deletes(state, payload)
        case PAYMENT_GETALL:
            return suggestion(state, payload)
        default:
            return state
    }
}

function list(state, payload) {
    state = Object.assign({}, state, payload)
    return state
}
function suggestion(state, payload) {
    state = Object.assign({}, state, {
        suggestion: payload
    })
    return state;
}
function detail(state, payload) {
    state = Object.assign({}, state, {
        item: payload
    })
    return state
}

function deletes(state, payload) {
    const data = state.data.filter(obj => obj.id !== payload)

    return Object.assign({}, state, { data })
}

function update(state, payload) {
    const data = state.data.map(obj => {
        if (obj.id === payload.id) {
            return { ...obj, ...payload }
        }
        return obj
    })

    return Object.assign({}, state, { data })
}

function insert(state, payload) {
    const data = [...state.data, payload]
    return Object.assign({}, state, { data })
}

export default reducer
